import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import SVG from './../SVG'

import './TextField.scss'

export const TextField = ({
  icon,
  value,
  label,
  onChange,
  onBlur,
  onKeyDown,
  name,
  type,
  disabled,
  tabIndex,
  autoFocus,
  placeholder,
  isRequired,
  isSubmitted,
  id,
  errorMsg,
  maxLength
}) => {
  const [inputValue, setValue] = useState(value)
  const field = useRef(null)
  const isMounted = useRef(false)
  const numberRegex = /^[0-9\b]+$/

  const onChangeHandler = event => {
    if (event.target.value === '' || type !== 'number' || (type === 'number' && numberRegex.test(event.target.value))) {
      isMounted.current && !disabled && setValue(event.target.value)
      isMounted.current && !disabled && onChange(event)
    }
  }

  const onEnterHandler = event => {
    isMounted.current && !disabled && onKeyDown(event)
  }

  const focus = () => {
    isMounted.current && !disabled && field.current.focus()
  }

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (value !== inputValue) {
      if (value === '' || type !== 'number' || (type === 'number' && numberRegex.test(value))) {
        isMounted.current && setValue(value)
      }
    }
  }, [inputValue, value])

  const isValid = isSubmitted && isRequired && isEmpty(inputValue)
  const getTextClass = () => {
    if (disabled) {
      return 'disabledText'
    }
    else if(!isEmpty(inputValue)){
      return 'has-value'
    }
    else{
      return ''
    }
  }
  return (
    <div className="TextFieldContainer__div">
      <div className={'textfield ' + (isValid ? 'is-error' : '')}>
        <input
          name={name}
          ref={field}
          value={inputValue}
          className={getTextClass()}
          type={type === 'password' || type === 'email' ? type : 'text'}
          onChange={onChangeHandler}
          onBlur={onBlur}
          onKeyDown={onEnterHandler}
          tabIndex={tabIndex}
          autoFocus={autoFocus} // eslint-disable-line
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        <label className="label" htmlFor={id || undefined} onClick={focus}>
          {label} {isRequired && ' *'}
        </label>
        {!isEmpty(icon) && <SVG>{icon}</SVG>}
      </div>
      <div className="error">
        {isValid &&
          (isEmpty(errorMsg) ? (
            <span>Please enter {label}.</span>
          ) : (
            <span>{errorMsg}</span>
          ))}
      </div>
    </div>
  )
}

TextField.propTypes = {
  icon: PropTypes.shape({}),
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  name: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  autoFocus: PropTypes.bool,
  isRequired: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  id: PropTypes.string,
  errorMsg: PropTypes.string,
  maxLength: PropTypes.number
}

TextField.defaultProps = {
  icon: {},
  value: '',
  label: '',
  onChange: () => {},
  onKeyDown: () => {},
  name: '',
  type: 'text',
  disabled: false,
  tabIndex: 0,
  autoFocus: false,
  isRequired: false,
  isSubmitted: false,
  id: '',
  errorMsg: '',
  maxLength: ''
}

export default TextField
